import { getGtmDataLayer } from '@airasia-common/libraries/factories/Analytics';
import { differenceInDaysFromCurrentDate } from '@airasia-common/libraries/datetime';
import { GA_VALUES, GA_EVENTS } from '../../constants';
import { types } from './map.meta';

const CATEGORY = 'Hotels SA|Hotel Select heatmap';

const mapRoomclickProduct = (
  id,
  name,
  price,
  bookingLeadDays,
  passengers,
  starRating,
  guestRating,
  hotelTags,
  guestRatingCount
  // strikeThroughPrice,
  // additionalRoomPrice,
) => {
  return {
    id, // vendor ID
    name,
    price, // hotel name
    brand: 'Hotel SA', // LOB
    category: 'Hotel SA - maps',
    variant: '',
    position: 1, // position of the hotel in the list
    dimension8: bookingLeadDays,
    dimension9: passengers,
    dimension10: passengers,
    dimension71: Number(starRating), // hotel star rating
    dimension72: Number(guestRating),
    dimension79: hotelTags, // hotel label from left, right, top bottom separate with '|', if there is no label replaced with 0.
    dimension103: guestRatingCount,
    // dimension104: strikeThroughPrice,
    // dimension110: additionalRoomPrice, //hotelAmenities
  };
};
const mapClick = (
  filter,
  name,
  price,
  id,
  starRating,
  guestRating,
  guestRatingCount,
  hotel
) => {
  const { checkin, guests } = filter;
  const getBookingLeadDays = checkin =>
    differenceInDaysFromCurrentDate(checkin);
  const getTotalPassengers = guests => {
    const passengers =
      (guests?.adults || 0) + (guests.children ? guests.children.length : 0);
    return passengers;
  };
  const getHotelTags = hotel => {
    const { aboveNameLabels, leftPillTexts, rightPillTexts } = hotel;
    const tagLeft = leftPillTexts ? 1 : 0;
    const tagRight = rightPillTexts ? 1 : 0;
    const tagTop = aboveNameLabels ? 1 : 0;
    const tagBottom = 0; // Bottom label is empty for now
    return `${tagLeft}|${tagRight}|${tagTop}|${tagBottom}`;
  };
  const bookingLeadDays = getBookingLeadDays(checkin);
  const passengers = getTotalPassengers(guests);
  const hotelTags = getHotelTags(hotel);
  return mapRoomclickProduct(
    id,
    name,
    price,
    bookingLeadDays,
    passengers,
    starRating,
    guestRating,
    hotelTags,
    guestRatingCount
  );
};

export default {
  [types.TRACK_MARKER_CLICK_WEB]: ({ payload: { price, currency } }) => {
    try {
      getGtmDataLayer(
        GA_EVENTS.trackEventNoEcommerce,
        CATEGORY,
        GA_VALUES.actions.click,
        `${price}|${currency}`
      );
    } catch (error) {
      console.error(error);
      return {};
    }
  },
  [types.TRACK_DEFAULT_HOTEL_CARD_CLICK_WEB]: ({
    payload: {
      name,
      id,
      price,
      guestRating,
      guestRatingCount,
      starRating,
      filter,
      hotel,
      currency,
    },
  }) => {
    try {
      const product = mapClick(
        filter,
        name,
        price,
        id,
        starRating,
        guestRating,
        guestRatingCount,
        hotel
      );
      return {
        event: GA_VALUES.events.productClick,
        ecommerce: {
          currencyCode: currency,
          click: {
            actionField: {
              list: 'Default Hotel Search Results',
            },
            products: [product],
          },
        },
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  },
  [types.TRACK_HOTEL_CARD_CLICK_WEB]: ({
    payload: {
      name,
      price,
      currency,
      id,
      guestRating,
      guestRatingCount,
      starRating,
      filter,
      hotel,
    },
  }) => {
    try {
      const product = mapClick(
        filter,
        name,
        price,
        id,
        starRating,
        guestRating,
        guestRatingCount,
        hotel
      );
      return {
        event: GA_VALUES.events.productClick,
        ecommerce: {
          currencyCode: currency,
          click: {
            actionField: {
              list: 'Hotel Search Results',
            },
            products: [product],
          },
        },
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  },
};
